// extracted by mini-css-extract-plugin
export default {"header":"table-class_header__WKc9a","title":"table-class_title__OYZky","header_status":"table-class_header_status__ekZCn"};